import { Component, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'fourd-test-system-notification',
    imports: [],
    templateUrl: './test-system-notification.component.html',
    providers: [CookieService]
})
export class TestSystemNotificationComponent {
  private cookieService = inject(CookieService);

  readonly cookieKey: string = 'user_accepted_testsystem';
  readonly cookieExpiresDays: number = 1 / 48; // Session cookies can remain in some browsers so using 30 mins
  show: boolean = false;

  constructor() {
    let cookieValue = this.cookieService?.get(this.cookieKey);
    if (!cookieValue) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  close(event: Event): void {
    event?.stopPropagation();
    this.show = false;
    this.cookieService?.set(this.cookieKey, this.cookieKey, { expires: this.cookieExpiresDays, path: '/', secure: true, sameSite: 'None' });
  }

}
